
import { StockMovement } from "@/models/base/stock-movement";
import { StockLocationConfig } from "@/models/dossier-configs/stock-location";
import { DossierConfigService, StockService, ToolbarService, ProductService } from "@/services";
import { printLocalDateTimeWithSeconds } from "@/utils/pretty-print";
import { IPaginationData } from "@/utils/query-params";
import { v4 } from "uuid";
import Vue from "vue";
import { DataTableCompareFunction, IDataTableColumn } from "winfakt-vue-components";
import Product from "@/models/base/product";

export default Vue.extend({
	data(){
		return {
			product: new Product(),
			items: [] as StockMovement[],
			count: 0,
			paginationData: {
				limit: 250,
				offset: 0,
				orderBy: "DateCreated",
				orderDirection: "ASC"
			} as IPaginationData,
			fetchThreadId: "",
			fromDate: undefined as undefined | Date,
			tillDate: undefined as undefined | Date,
			saleNr: "",
			prevFetchSaleNr: "",
			totals: [] as number[]
		};
	},
	computed: {
		columns():IDataTableColumn[]{
			let result:IDataTableColumn[] = [
				{
					name: this.$ct("common.date.date").toString(),
					property: "DateCreated",
					width: "140px",
					print: printLocalDateTimeWithSeconds
				},
				{
					name: this.$ct("common.document").toString(),
					property: "SaleNr",
					width: "100px"
				},
				{
					name: this.$ct("common.customer").toString(),
					property: "CustomerName",
					width: "180px",
					disableSorting: true
				},
			];

			let conf = DossierConfigService.getStockLocationConfig();
			for (let i = 1; i <= StockLocationConfig.MAX_ID; i++){
				result.push({
					name: conf.getLocationName(i),
					property: `Location${i}Qty`,
					width: "100px",
					disableSorting: true
				});
			}

			return result;
		},
		compareFunc():DataTableCompareFunction{
			return StockMovement.isSameRecord;
		}
	},
	watch: {
		fromDate(){
			this.fetch();
		},
		tillDate(){
			this.fetch();
		},
	},
	methods: {
		async fetch(){
			let threadId = v4();
			this.fetchThreadId = threadId;
			try{
				let result = await StockService.getStockMovement(this.product.ID, this.paginationData, this.fromDate, this.tillDate, this.saleNr);
				if (this.fetchThreadId != threadId) return;
				this.prevFetchSaleNr = this.saleNr;
				this.items = result.data;
				this.count = result.records;
				this.totals = result.totals;
			}catch(err){
			}
			this.fetchThreadId = "";
		},
		async fetchMore(){
			if (this.count <= this.items.length) return;
			if (this.fetchThreadId) return;
			let threadId = v4();
			this.fetchThreadId = threadId;
			try{
				this.paginationData.offset = this.items.length;
				let result = await StockService.getStockMovement(this.product.ID, this.paginationData, this.fromDate, this.tillDate, this.saleNr);
				this.items.push(...result.data);	if (this.fetchThreadId != threadId) return;
			}catch(err){
			}
			this.fetchThreadId = "";
		},
		onScroll(event:Event) {
			let table = event.target as HTMLElement;
			let lastChild = table.lastChild as HTMLElement;
			if (!lastChild) {
				return;
			}

			let tableRect = table.getBoundingClientRect();
			let childRect = lastChild.getBoundingClientRect();


			let tableBottomY = tableRect.top + tableRect.height;
			if (childRect.top < (tableBottomY + 4000)) {
				this.fetchMore();
			}
		},
		onOrder(event:{order:string, ascending:boolean}){
			this.paginationData.orderBy = event.order;
			this.paginationData.orderDirection = event.ascending ? "ASC" : "DESC";
			this.fetch();
		},
		fetchIfSaleNrChanged(){
			if (this.saleNr == this.prevFetchSaleNr) return;
			this.fetch();
		}
	},
	async created(){
		let productId = this.$route.params.productId;
		this.product = await ProductService.getProduct(parseInt(productId));
		ToolbarService.title = this.$ct("stock-movement-of", {sku: this.product.Sku});
		this.fetch();
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
